import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { useStaticQuery, graphql } from 'gatsby'
import Img from "gatsby-image"
import icon from "../images/logo_ud_white.svg"
import styled from 'styled-components'

const Icon = styled.img`
  width: 36px;
  height: 36px;
  margin: 0;
  vertical-align: bottom;
`;
const Text = styled.span`
  padding: 0 10px;
`;

const Header = ({ siteTitle }) => {
  return (
  <header
    style={{
      background: `#2a3a91`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 1460,
        padding: `8px 2.175rem`,
      }}
    >
      <div style={{
        fontFamily: "Helvetica",
        fontSize: "20px",
        position: "relative"
      }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          <Icon src={icon}/>
          <Text>{siteTitle}</Text>
        </Link>
      </div>
    </div>
  </header >
)};

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
